import { Directive, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appPhoneNumberPrefix]'
})
export class PhoneNumberPrefixDirective {
  @Input('appPhoneNumberPrefix') dialCode!: string;

  constructor(private control: NgControl) {}

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    const cursorPos = (event.target as HTMLInputElement).selectionStart || 0;
    if (
      (event.key === 'Backspace' && cursorPos <= this.dialCode.length) ||
      (event.key === 'Delete' && cursorPos < this.dialCode.length)
    ) {
      event.preventDefault();
    }
  }

  @HostListener('blur')
  onBlur(): void {
    const ctrl = this.control.control!;
    setTimeout(() => {
      const value = ctrl.value || '';
      if (!value) {
        ctrl.setValue(this.dialCode, { emitEvent: false });
        return;
      }
      if (!value.startsWith(this.dialCode)) {
        const rest = value.replace(/^\+?\d*/, '');
        ctrl.setValue(this.dialCode + rest, { emitEvent: false });
      }
    }, 0);
  }
}
